<template>

  <div>
  <section class="mb-5 pt-5 relative nooverflow try-it-section hidden-md-and-down" style="height:810px;" >

			<div style="height: 375px;width: 120%;background: #5fcf80;position: absolute;top: -29px;transform: rotate(2deg);left: -40px;z-index: 1;"></div>

			<v-layout column wrap align-center class="pt-3 relative" style="z-index:6">
				<v-flex xs12 sm4>
					<div class="text-xs-center">
						<h2 class="display-2 font-weight-light mt-2 mb-5 pt-3 pb-4">
							Try It Out
						</h2>
					</div>
				</v-flex>



				<!-- row1 -->
				<v-layout row class="" style="position:relative;z-index:2">

				<!-- English -->
				<v-flex xs12>
					<v-layout row wrap class="try-it-container" style="--background:#a5eaa5;top: 13px;left: 19px;" id="maddy">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-f1.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person">
									<span >Maddy, </span><span class="try-it-country">England</span>
								</span>
								</div>
								<div class="try-it-text" >
									Hi, Lingo AV is cool!
								</div>
								<div class="mt-3">

									<lingo_audio slot="activator" :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Maddy_wav"></lingo_audio>

								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>

				<!-- German -->
				<v-flex xs12>
					<v-layout row wrap class="try-it-container" style="--background:#fdefa8;top:-5px;left:10px" id="dietmar">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-m1.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person">
									<span>Dietmar, </span><span class="try-it-country">Germany</span>
								</span>
								</div>
								<div class="try-it-text" >
									Servus, Das Macht Spa&#xDF;!
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Dietmar_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>


				<!-- French -->
				<v-flex xs12>
					<v-layout row wrap class="try-it-container" style="--background:#a4e5f5;left: -10px;top: 34px;" id="lisette">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-f2.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person">
									<span>Lisette, </span><span class="try-it-country">France</span>
								</span>
								</div>
								<div class="try-it-text" >
									Salut! Quoi de neuf?
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Lisette_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>
				</v-layout>


				<!-- row2 -->
				<v-layout row class="" style="position:relative;z-index:2">


				<!-- Korean -->
				<v-flex xs12>
					<v-layout row wrap class="try-it-container" style="--background:#ffd1d1;top: 3px;left: 53px;" id="minjung">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-f3.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person">
									<span>Min Jung, </span><span class="try-it-country">Korea</span>
								</span>
								</div>
								<div class="try-it-text" >
									&#47564;&#45208;&#49436; &#48152;&#44049;&#49845;&#45768;&#45796; <!-- https://www.textfixer.com/html/html-character-encoding.php -->
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Ming_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>


				<!-- Russian -->
				<v-flex xs12>
					<v-layout row wrap class="try-it-container" style="--background:rgb(233, 215, 253);top: 28px;left: -8px;" id="igor">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-m2.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person">
									<span>Igor, </span><span class="try-it-country">Russia</span>
								</span>
								</div>
								<!--https://onlineutf8tools.com/convert-utf8-to-html-entities-->
								<div class="try-it-text" >
									&Bcy;&lcy;&icy;&ncy;&comma;&#x20;&ecy;&tcy;&ocy;&#x20;&kcy;&rcy;&ucy;&tcy;&ocy;&excl;
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Igor_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>

				<!-- Spanish -->
				<v-flex xs12>
					<v-layout row wrap class="try-it-container" style="--background:#f5c9a2;top: 18px;left: -51px;" id="celesta">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-f4.png"/>
						</div>
						<div class=" pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person">
									<span>Celesta, </span> <span class="try-it-country">Spain</span>
								</span>
								</div>
								<div class="try-it-text" >
									Una Copa de Sangria!
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Celeste_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>

				</v-layout>

				<v-flex xs12 class="relative mt-5">
					<v-btn class="mt-5 elevation-0" dark large @click='login()' color="primary" style="position:relative;top:-10px;box-shadow:#0f9c69 -1px 0px 17px -3px !important" to="/app/gallery">Check All Voices</v-btn>
					<img src="../../../assets/hint2.png" style="position: absolute;bottom: 3px;left: -279px;transform: rotate(-1deg);"/>
				</v-flex>

			</v-layout>
		</section>


<!-- mobile version -->
<section class="mb-5 relative nooverflow try-it-section-mobile hidden-lg-and-up" >

			<div style="height: 275px;width: 120%;background: rgb(98, 208, 131);position: absolute;top: -29px;transform: rotate(2deg);left: -40px;z-index: 1;"></div>

			<v-layout column wrap align-center class="pt-3 relative" style="z-index:6">
				<v-flex xs12 sm4>
					<div class="text-xs-center">
						<h2 class="display-2 font-weight-light mt-2 mb-5 pt-3 pb-4">
							Try It Out
						</h2>
					</div>
				</v-flex>



				<v-layout column style="position:relative;z-index:2">

				<!-- English -->
				<v-flex md12>
					<v-layout row wrap class="try-it-container" id="maddy">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-f1.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person ">
									<span>Maddy, </span><span class="try-it-country">England</span>
								</span>
								</div>
								<div class="font-weight-light try-it-text" >
									Hi, Lingo AV is cool!
								</div>
								<div class="mt-3">

									<lingo_audio slot="activator" :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Maddy_wav"></lingo_audio>

								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>

				<!-- German -->
				<v-flex md12>
					<v-layout row wrap class="try-it-container" id="dietmar">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-m1.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person ">
									<span>Dietmar, </span><span class="try-it-country">Germany</span>
								</span>
								</div>
								<div class="font-weight-light try-it-text" >
									Servus, das macht Spa&#xDF;!
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Dietmar_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>


				<!-- French -->
				<v-flex md12>
					<v-layout row wrap class="try-it-container" id="lisette">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-f2.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person ">
									<span>Lisette, </span><span class="try-it-country">France</span>
								</span>
								</div>
								<div class="font-weight-light try-it-text" >
									Salut! Quoi de neuf?
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Lisette_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>

				<!-- Korean -->
				<v-flex md12>
					<v-layout row wrap class="try-it-container" id="minjung">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-f3.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person ">
									<span>Min Jung, </span><span class="try-it-country">Korea</span>
								</span>
								</div>
								<div class="font-weight-light try-it-text" >
									&#47564;&#45208;&#49436; &#48152;&#44049;&#49845;&#45768;&#45796; <!-- https://www.textfixer.com/html/html-character-encoding.php -->
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Ming_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>


				<!-- Russian -->
				<v-flex md12>
					<v-layout row wrap class="try-it-container" id="igor">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-m2.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person ">
									<span>Igor, </span><span class="try-it-country">Russia</span>
								</span>
								</div>
								<div class="font-weight-light try-it-text" >
									&#x411;&#x43B;&#x44F;&#x434;, &#x435;&#x442;&#x43E; &#x43A;&#x440;&#x443;&#x442;&#x43E;!
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Igor_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>

				<!-- Spanish -->
				<v-flex md12>
					<v-layout row wrap class="try-it-container" id="celesta">
						<div class="try-it-avatar">
							<img src="../../../assets/avatar-f4.png"/>
						</div>
						<div class="pt-3">
							<v-layout column wrap >
								<div>
								<span class="mb-3 try-it-person ">
									<span>Celesta, </span><span class="try-it-country">Spain</span>
								</span>
								</div>
								<div class="font-weight-light try-it-text" >
									Una Copa de Sangria!
								</div>
								<div class="mt-3">
									<lingo_audio :play_button_class="`try-it-play`" :label_class="`try-it-generator`" :label_text="`Generate Audio`" :file="Celeste_wav"></lingo_audio>
								</div>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>

				</v-layout>

				<v-flex md12 class="relative mt-5 hidden-md-and-down">
					<v-btn class="mt-5 round-button elevation-0" dark large @click='login()' color="primary" style="position:relative;top:-10px;box-shadow:#0f9c69 -1px 0px 17px -3px !important" to="/app/gallery">Check All Voices</v-btn>
					<img src="../../../assets/hint2.png" style="position: absolute;bottom: 3px;left: -279px;transform: rotate(-1deg);"/>
				</v-flex>

				<v-flex md12 class="relative mt-5 hidden-lg-and-up">
					<v-btn class="mt-5 elevation-0" dark large @click='login()' color="primary" style="position:relative;top:-10px;box-shadow:#0f9c69 -1px 0px 17px -3px !important" to="/app/gallery">Check All Voices</v-btn>
				</v-flex>

			</v-layout>
		</section>

  </div>

</template>

<style scoped>

.try-it-avatar img {
	width: 100px;
	margin-top: 10px;
}

.try-it-person {
	font-size:1.3rem;
	padding: 12px;
	padding-top:7px;
	background: #f5f7d7;
    border-radius: 10px;
}

.try-it-person span {
	position:relative;
	top:-3px;
}

#maddy:hover {
	background:#a5eaa5;
}

#dietmar:hover {
	background:#fdefa8;
}

#lisette:hover{
	background:#a4e5f5;
}

#minjung:hover {
	background:#ffd1d1;
}

#igor:hover {
	background:rgb(233, 215, 253);
}

#celesta:hover {
	background:#f5c9a2;
}

.try-it-container {
	width:370px;
	background:white;
	-border-radius:40px;
	padding-right:5px;
	padding-top:20px;
	padding-bottom:20px;
	position:relative;
	box-shadow:-11px -3px 18px -14px rgba(138, 135, 135, 0.63);
	-webkit-box-shadow:-11px -3px 18px -14px rgba(138, 135, 135, 0.63);
	transition:all 0.4s;
}

.try-it-section:hover .try-it-container {
	left:0px !important;
	top:0px !important;
	transition:all 1s;
}

.try-it-container:hover .try-it-person {
	background: transparent;
}

.try-it-container:hover .try-it-avatar {
	transform:scale(1.1);
}

.try-it-container:hover .try-it-text {
	transform:scale(1.05);
}

.try-it-country {
	color:#808080;
}

.try-it-play {
	color:rgb(80, 80, 80) !important;
	font-size:2.5rem;
	position:relative;
	left:-4px;
}

.try-it-play:hover {
	color:#15b681 !important;
}

.try-it-avatar {
	padding-left:20px;
	margin-right:2px;
	transition:transform 1s;
}

.try-it-text {
	background:white;
	padding: 13px;
	--padding-left: 0px;
	border-radius: 21px 21px 25px 0px;
	position: relative;
	font-size:1.3rem;
	transition:transform 0.6s;
	color:#3f4348;
	font-weight: 600;
}

</style>

<style>
.try-it-generator {
	font-size: 1rem;
	position:relative;
	left:-10px;
	font-weight: 600;
}


</style>

<script>
import lingo_audio from '../AudioPlayer';
import Maddy_wav from '../../../assets/audio/homepage/maddy_home.wav';
import Dietmar_wav from '../../../assets/audio/homepage/dietmar_home.wav';
import Lisette_wav from '../../../assets/audio/homepage/lisette_home.wav';
import Ming_wav from '../../../assets/audio/homepage/ming_home.wav';
import Igor_wav from '../../../assets/audio/homepage/igor_home.wav';
import Celeste_wav from '../../../assets/audio/homepage/celeste_home.wav'

export default {
  name: "try_it_section",
  data() {
    return {
      Dietmar_wav: Dietmar_wav,
      Maddy_wav: Maddy_wav,
      Lisette_wav: Lisette_wav,
      Ming_wav: Ming_wav,
      Igor_wav: Igor_wav,
      Celeste_wav: Celeste_wav
    };
  },
  components: {
			lingo_audio,
		}
};
</script>
